const Email = () =>
  import(
    /* webpackChunkName: "messages-email" */ '@/pages/message/messages/email/index.vue'
  )
const CreateEmail = () =>
  import(
    /* webpackChunkName: "messages-email" */ '@/pages/message/messages/email/create.vue'
  )
const EditEmail = () =>
  import(
    /* webpackChunkName: "messages-email" */ '@/pages/message/messages/email/edit.vue'
  )

export default {
  path: 'email',
  meta: {
    label: 'email',
    auth: 'email'
  },
  component: {
    name: 'Email',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageMessagesEmail',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Email
    },
    {
      name: 'MessageCreateMessagesEmail',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateEmail
    },
    {
      name: 'MessageEditMessagesEmail',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditEmail,
      props: true
    }
  ]
}
